export default "/images/ararat_bank.png?315c55ea4751fb2b3f91ecfb0725b199";